export function getToasterProps(appVariant) {
  if (appVariant === 'customer') {
    return { position: 'top-right' };
  }

  return {
    position: 'top-center',
    containerStyle: { top: '4.5rem' },
  };
}
